import Utils from '../../services/Utils'
/**
 * @namespace SiteLayoutHelper 
 */
const FooterNotAlowedPages = {
    VirtualSports: '/games/virtual-sport',
}

const NavBarNotAlowedPages = {
    VirtualSports: '/games/virtual-sport',
    PlayMobile: '/play-mobile',
    PlayFullScreen: '/play-fullscreen'
}

export const SiteLayoutHelper = {
    /**
     * Check navigation bar vidsibilty on appropriate page 
     * @param {string } page Page  
     * @returns {Boolean}
     */
    isNotAllowedPage(pageEnum) {
        const pages = Object.values(pageEnum);
        const isVisible = !pages.reduce((previousValue, currentValue) => (previousValue || window.location.pathname.includes(currentValue)), false);
        return isVisible;
    },
    isNavBarVisible() {
        const isNavBarNotVisible = SiteLayoutHelper.isNotAllowedPage(NavBarNotAlowedPages);
        return Utils.isTablet() && isNavBarNotVisible;
    },

    isFooterVisible() {
        const isFooterNotVisible = SiteLayoutHelper.isNotAllowedPage(FooterNotAlowedPages);
        return !(Utils.isTablet() && !isFooterNotVisible);
    },
    /**
     * Check navigation bar vidsibilty on appropriate page 
     * @returns {Number}
     */
    getHeaderHeight() {
        const headerHeight = document.querySelector(".header-block").clientHeight;
        return headerHeight;
    },
    getGameFrameFixedHeight() {
        window.scrollTo(0, 0)
        const gameFrame = document.getElementById("gameFrameContainer");
        const navBar = document.querySelector(".mobile-nav_list");
        const navBarHeight = navBar && navBar.clientHeight > 0 ? navBar.clientHeight : 0;

        var gameFrameTop = gameFrame ? gameFrame?.getBoundingClientRect().top : 0;
        if (window.innerHeight - gameFrameTop - navBarHeight > 1000) {
            console.log('getGameFrameFixedHeight', window.innerHeight, gameFrameTop, navBarHeight)
        }
        return window.innerHeight - gameFrameTop - navBarHeight;
    }
}
